import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody45.css';

import clientimg from '../images/case-study-client45.webp'
import outcome from '../images/outcome45.webp'

import sm1 from '../images/cs45so1.webp'
import sm2 from '../images/cs45so2.webp'
import sm3 from '../images/cs45so3.webp'
import sm4 from '../images/cs45so4.webp'


const Casestudybody45 = () => {

    return (
        <>
        <section className='casestudybody45-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A family office managing a real estate portfolio,  aiming to enhance governance and establish a proactive framework for enterprise-wide risk identification and mitigation   </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought to implement a comprehensive risk management strategy to identify, assess,and manage key risks across its operations, improving preparedness, transparency, and decision-making</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody45-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Enterprise Risk Awareness: </h4>
                          <p>Conducted workshops and sessions to <span style={{color:"#03A393",fontWeight:700}}>enhance awareness</span> and understanding of <span style={{color:"#03A393",fontWeight:700}}>key Enterprise Risk Management (ERM) concepts</span> within the client organization</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Risk Categorization:</h4>
                          <p>Identified and classified risks across key dimensions <span style={{color:"#03A393",fontWeight:700}}> - strategic, operational, developmental, legal,</span> and <span style={{color:"#03A393",fontWeight:700}}> financial</span> - to establish a structured risk taxonomy</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Risk Assessment Framework:</h4>
                          <p>Evaluated the <span style={{color:"#03A393",fontWeight:700}}> probability of occurrence</span> and <span style={{color:"#03A393",fontWeight:700}}> quantified potential impacts,</span> mapping results onto an inherent <span style={{color:"#03A393",fontWeight:700}}> risk matrix</span> to visualize priority areas</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Stakeholder Alignment:</h4>
                          <p>Defined and assigned stakeholder responsibilities using the <span style={{color:"#03A393",fontWeight:700}}> RAPID framework</span>, ensuring <span style={{color:"#03A393",fontWeight:700}}> clear ownership</span> and <span style={{color:"#03A393",fontWeight:700}}> accountability</span> for each risk area</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Control & Mitigation Strategy:</h4>
                          <p>Established procedures for <span style={{color:"#03A393",fontWeight:700}}> assessing, controlling</span>, and <span style={{color:"#03A393",fontWeight:700}}> mitigating key risks</span> through coordinated <span style={{color:"#03A393",fontWeight:700}}> stakeholder engagement</span> and <span style={{color:"#03A393",fontWeight:700}}> defined action plans</span></p>
                        </div>
                      </div>     

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Monitoring & Continuous Improvement:</h4>
                          <p>Designed a mechanism for <span style={{color:"#03A393",fontWeight:700}}> continuous monitoring</span> and <span style={{color:"#03A393",fontWeight:700}}> improvement</span>, supported by <span style={{color:"#03A393",fontWeight:700}}> standardized reporting</span> and <span style={{color:"#03A393",fontWeight:700}}> regular stakeholder reviews</span> to ensure responsiveness to emerging risk</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody45-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client gained a responsive and structured ERM framework that enhanced its ability to anticipate, evaluate, and mitigate potential risks. The approach strengthened internal accountability, improved risk visibility, and enabled management to make proactive, data-informed decisions across the enterprise</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody45
